@if (visible){
@if (breadcrumbType == '0') {
  <div fxHide fxShow.gt-sm>
    &nbsp;@if (router.url != '/' && router.url != '/home') {
    <div id="breadcrump" fxLayout="row wrap">
      <div fxFlex="100">
        <mat-card appearance="outlined" style="border-radius: 0px;" fxLayout="row" class="breadcrumb light-block">
          @if (router.url != '/') {
            <a routerLink="/" class="breadcrumb-item" fxLayout="row" fxLayoutGap="5px"
              fxLayoutAlign="start center">
              <mat-icon>home</mat-icon>
              <span class="breadcrumb-title">HOMEPAGE</span>
            </a>
          }
          @for (breadcrumb of breadcrumbs; track breadcrumb; let i = $index) {
            <div class="breadcrumb-item upperCase" fxLayout="row"
              fxLayoutAlign="start center">
              <a class="cursor-pointer" [hidden]="i == (breadcrumbs.length - 1)"
              (click)="navigate(breadcrumb)">{{breadcrumb.name}}</a>
              <span [hidden]="i != (breadcrumbs.length - 1)" class="breadcrumb-title active"><b
              class="text">{{breadcrumb.name}}</b></span>
            </div>
          }
        </mat-card>
        @if (displayDescripion) {
          <div fxLayout="row">
            <small style="padding-bottom:10px;padding-left:5px;">{{categoryDetails?.description}}</small>
          </div>
        }
      </div>
    </div>
  }
</div>
}


@if (breadcrumbType == '1') {
  <div fxHide fxShow.gt-sm>
    &nbsp;@if (router.url != '/' && router.url != '/home') {
    <div id="breadcrump" fxLayout="row wrap">
      <div fxFlex="100">
        <mat-card appearance="outlined" style="border-radius: 0px;" fxLayout="row" class="breadcrumb light-block2">
          @if (router.url != '/') {
            <a routerLink="/" class="breadcrumb-item2" fxLayout="row" fxLayoutGap="5px"
              fxLayoutAlign="start center">
              <p class="breadcrumb-title2">HOMEPAGE</p>
            </a>
          }
          @for (breadcrumb of breadcrumbs; track breadcrumb; let i = $index) {
            <div class="breadcrumb-item2 upperCase" fxLayout="row"
              fxLayoutAlign="start center">
              <a class="cursor-pointer" [hidden]="i == (breadcrumbs.length - 1)" (click)="navigate(breadcrumb)">
                <p class="upperCase2">{{breadcrumb.name}}</p>
              </a>
              <span [hidden]="i != (breadcrumbs.length - 1)" class="breadcrumb-title active"><b
              class="text upperCase2">{{breadcrumb.name}}</b></span>
            </div>
          }
        </mat-card>
        @if (displayDescripion) {
          <div fxLayout="row">
            <small style="padding-bottom:10px;padding-left:5px;">{{categoryDetails?.description}}</small>
          </div>
        }
      </div>
    </div>
  }
</div>
}

@if (breadcrumbType == '2') {
  <div fxHide fxShow.gt-sm>
    &nbsp;@if (router.url != '/' && router.url != '/home') {
    <div id="breadcrump" fxLayout="row wrap">
      <div fxFlex="100">
        <mat-card appearance="outlined" style="border-radius: 0px;" fxLayout="row" class="breadcrumb light-block3">
          @if (router.url != '/') {
            <a routerLink="/" class="breadcrumb-item3" fxLayout="row" fxLayoutGap="5px"
              fxLayoutAlign="start center">
              <p class="breadcrumb-title2">HOMEPAGE</p>
            </a>
          }
          @for (breadcrumb of breadcrumbs; track breadcrumb; let i = $index) {
            <div class="breadcrumb-item3 upperCase" fxLayout="row"
              fxLayoutAlign="start center">
              <a class="cursor-pointer " [hidden]="i == (breadcrumbs.length - 1)" (click)="navigate(breadcrumb)">
                <p class="upperCase2">{{breadcrumb.name}}</p>
              </a>
              <span [hidden]="i != (breadcrumbs.length - 1)" class="breadcrumb-title active"><b
              class="text upperCase2">{{breadcrumb.name}}</b></span>
            </div>
          }
        </mat-card>
        @if (displayDescripion) {
          <div fxLayout="row">
            <small style="padding-bottom:10px;padding-left:5px;">{{categoryDetails?.description}}</small>
          </div>
        }
      </div>
    </div>
  }
</div>
}
}

@if (displayCategoryImage) {
  <div fxLayoutAlign="start stretch" ngClass.gt-sm="padding-b10" fxLayout="column">
    <img style="width: 100%;" [src]="path" onerror="this.src=''" loading="lazy" [style.height]="imgHeight" [ngStyle.lt-md]="{'height': imgMobHeight}">
  </div>
}
